import { render, staticRenderFns } from "./applyTipsDialog.vue?vue&type=template&id=4635ff34&scoped=true&"
import script from "./applyTipsDialog.vue?vue&type=script&lang=ts&"
export * from "./applyTipsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./applyTipsDialog.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./applyTipsDialog.vue?vue&type=style&index=1&id=4635ff34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4635ff34",
  null
  
)

export default component.exports